// File: src/hooks/useRefundProjects.js

import { useState, useEffect } from "react";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";
import { toast } from "react-toastify";

export function useRefundProjects() {
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoader(true);
        const val = localStorage.getItem("accessToken");

        try {
            const response = await axios.get(Api_Url + "/credit", {
                headers: {
                    Authorization: "Bearer " + val,
                },
            });

            const result = response?.data?.data || [];
            // console.log(result);
            setData(result);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Optionally show an error message to the user here
        } finally {
            setLoader(false);
        }
    };

    const handleToggle = async (id) => {
        const val = localStorage.getItem("accessToken");
        // console.log(id);

        try {
            const response = await axios.patch(
                Api_Url + "/credit",
                { id: id },
                {
                    headers: {
                        Authorization: "Bearer " + val,
                        "Content-Type": "application/json",
                    },
                }
            );

            const updatedData = data.map((item) =>
                item._id === id ? { ...item, isActive: !item.isActive } : item
            );
            setData(updatedData);

            toast.success("Project status updated successfully!");
            // console.log("Toggle success:", response.data);
        } catch (error) {
            console.error("Toggle failed:", error?.response || error.message);
            toast.error("Failed to update status.");
        }
    };

    return {
        data,
        loader,
        handleToggle,
        getData
    };
}
